import React, {useEffect, useState} from 'react';
import {SaveOutlined} from "@ant-design/icons";
import axios from "axios";
import {header} from "../../../../../../../../components/api/Header";
import { getEnv } from "../../../../../../../../lib/env";
function AddIstemolchi({setAddPopup}) {
    let manbalar = localStorage.getItem('sfr-hm-manbalar')?JSON.parse(localStorage.getItem('sfr-hm-manbalar')):[]
    const [checkedgms,setCheckedgms] = useState([])
    const [checkedManbalar,setCheckedManbalar] = useState([])
    const [gms, setGms] = useState([])
    const season = localStorage.getItem('sfr-hm-season')
    const ekinlar = localStorage.getItem('sfr-hm-'+season+'-ekinids')?JSON.parse(localStorage.getItem('sfr-hm-'+season+'-ekinids')):[]
    const istemolchilar = localStorage.getItem('sfr-hm-istemolchilar')?JSON.parse(localStorage.getItem('sfr-hm-istemolchilar')):[]
    const [name, setName] = useState('')
    useEffect(()=>{
        const fetchGms = async (e) => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/gms?season="+season+"&ekinlar="+e, header())
                .catch(err=>{
                    console.log("Xato",err)
                })
            if(res){
                setGms(res.data)
            }
        }
        if(season){
            if(ekinlar){
                fetchGms(ekinlar)
            }
        }
    },[season])
    const checkManba = (e,i,id) => {
        if(e){
            let m = [...checkedManbalar]
            let man = manbalar[i]
            man.manba_index = i
            m.push(man)
            setCheckedManbalar(m)
        }else{
            let m = checkedManbalar.filter(c=>c.id!==id)
            setCheckedManbalar(m)
        }
    }
    const checkGms = (e,i,v) => {
        if(e){
            let gm = [...checkedgms]
            gm.push({i,v})
            setCheckedgms(gm)
        }else{
            let gm = checkedgms.filter(g=>g.i!==i)
            setCheckedgms(gm)
        }
    }
    const SaveHandler = () => {
        if(!checkedManbalar.length){
            alert('Suv manbasini tanlamadingiz!')
            return false
        }else if(!checkedgms.length){
            alert('Gidromodul tanlamadingiz!')
            return false
        }else if(name == ''){
            alert('Istemolchi nomini kiriting!')
            return false
        }else{
            let id = 0
            let ist = []
            if(istemolchilar.length){
                ist = istemolchilar
                ist.map((v,i)=>{
                    if(v.id > id){
                        id = v.id
                    }
                    return false
                })
            }
            const istemolchi_id = id+1;
            for(var i = 0; i < checkedManbalar.length; i++){
                let c = []
                for(var j = 0; j < checkedgms.length; j++){
                    c.push(checkedgms[j].v)
                }
                id++;
                ist.push({
                    istemolchi_id,
                    id:id+1,
                    name,
                    mid:checkedManbalar[i].id,
                    mname:checkedManbalar[i].name,
                    fik:checkedManbalar[i].fik,
                    gms:c,
                    limit:{daryo:'',yer:'',zovur:''}
                })
            }
            localStorage.setItem('sfr-hm-istemolchilar',JSON.stringify(ist))
            setAddPopup(false)
            window.location = '/sfr/gidromodul/new/insert/istemolchilar'
        }
    }
    return (
        <div className="row">
            <div className="col-12">
                <h3 className="my-4 text-center">Suv manbalari</h3>
            </div>
            <div className="col-12">
                <div className="row">
                    <div className="col-7">
                        <div>
                            <input type="text" className="form-control" placeholder="Istemolchi nomi" onChange={e=>setName(e.target.value)} value={name}/>
                            <br/>
                        </div>
                        <div className="flextableblock">
                            <table className="table table-bordered  change_gidromodule_table">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>Suv manbalari</th>
                                    <th>FIK</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    manbalar.length?
                                        manbalar.map((m,i)=>{
                                            return <tr key={i}>
                                                <td><input type="checkbox" onChange={e=>checkManba(e.target.checked,i,m.id)}/></td>
                                                <td>
                                                    {m.name}
                                                </td>
                                                <td style={{maxWidth:"50px"}}>
                                                    {m.fik}
                                                </td>
                                            </tr>
                                        })
                                        :null
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-3 offset-1 d-flex flex-column justify-content-between pb-5">
                        <div>
                            <h3>Gidromodullar</h3>
                            <table className="table table-bordered  change_gidromodule_table">
                                <tbody>
                                {
                                    gms.length?
                                        gms.map((g,i)=>{
                                            return <tr key={i}>
                                                <td>
                                                    <label htmlFor={"ch"+i} className="d-block">
                                                        <input type="checkbox" id={"ch"+i} className={"checkbox"+i} onChange={e=>checkGms(e.target.checked,i,g.raqami)}/>
                                                        &nbsp;&nbsp;&nbsp;
                                                        {g.raqami}
                                                    </label>
                                                </td>
                                            </tr>
                                        })
                                        :null
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="row">
                    <div className="col-3 offset-9">
                        <div>
                            <button className="btn btn-sm btn-success d-flex align-items-center" onClick={()=>SaveHandler()}>
                                Saqlash&nbsp;&nbsp;<SaveOutlined/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddIstemolchi;